<template>
    <vue-advanced-chat
        ref="vacRef"
        :height="chatWindowHeight"
        :username-options="JSON.stringify(usernameOptions)"
        :scroll-distance="60"
        :auto-scroll="JSON.stringify(autoScrollOptions)"
        :single-room="'true'"
        :current-user-id="currentUserId"
        :show-audio="'false'"
        :show-files="'false'"
        :accepted-files="'.jpeg,.jpg,.gif,.png,.svg,.docx,.ppt,.xls'"
        :rooms="JSON.stringify(rooms)"
        :messages="JSON.stringify(messages)"
        :message-selection-actions="JSON.stringify(messageSelectionActions)"
        :message-actions="JSON.stringify(messageActions)"
        :messages-loaded="allMessagesLoaded"
        :rooms-loaded="roomsLoaded"
        :load-first-room="false"
        :room-info-enabled="'false'"
        :text-formatting="JSON.stringify(textFormatting)"
        :textarea-auto-focus="'false'"
        :link-options="JSON.stringify(linkOptions)"
        :styles="JSON.stringify(styleOverrides)"
        :show-reaction-emojis="'false'"
        @send-message-reaction="sendMessageReaction"
        @message-selection-action-handler="messageSelectionActionHandler"
        @fetch-messages="fetchMessages"
        @send-message="sendMessage"
        @edit-message="editMessage"
        @delete-message="deleteMessage"
        @read-new-message="markNewMessageAsRead"
    >
        <div v-for="message in messages" :slot="'pencil-icon_' + message._id">
            <span>Edited</span>
        </div>
    </vue-advanced-chat>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { register } from "../vue-advanced-chat/dist/vue-advanced-chat.es.js";
register();
export default {
    props: {
        chatNamespace: String,
        primaryParticipantId: Number,
        primaryParticipantType: Number | String,
        primaryParticipantTitle: String,
        shouldRefreshMessages: Boolean,
    },
    data() {
        return {
            allMessagesLoaded: false,
            roomsLoaded: false,
            currentUserId: `${localStorage.getItem("userId")}`,
            autoScrollOptions: {
                send: { new: true, newAfterScrollUp: true },
                receive: { new: false, newAfterScrollUp: false }
            },
            usernameOptions: { minUsers: 0, currentUser: false },
            styleOverrides: {
                general: {
                    backgroundColorButton: "var(--wf-primary)",
                    colorButtonClear: "var(--wf-primary)"
                },
                icons: {
                    emoji: "var(--wf-primary)",
                    send: "var(--wf-primary)"
                }
            },
            textFormatting: { disabled: false, singleLine: true },
            /* textFormatting disabled: true - empty
             * textFormatting singleLine: true - everything text , message
             * v2.0.11 has bugs linkOptions does not get work as npm package
             * so copied vac dist folder from node_modules and importing js
             */
            linkOptions: {
                disabled: false,
                target: "_blank",
                rel: "noopener noreferrer"
            },
            messageSelectionActions: [
                {
                    name: "deleteMessages",
                    title: "Delete",
                    onlyMe: true
                }
            ],
            messageActions: [
                {
                    name: "replyMessage",
                    title: "Reply"
                },
                {
                    name: "editMessage",
                    title: "Edit Message",
                    onlyMe: true
                },
                {
                    name: "deleteMessage",
                    title: "Delete Message",
                    onlyMe: true
                },
                {
                    name: "selectMessages",
                    title: "Select",
                    onlyMe: true
                }
            ],
            rooms: [],
            messages: [],
            pageNumber: 1,
            lastUpdatedTimestamp: null,

        };
    },
    computed: {
        ...mapGetters([
            "allActiveUsers",
        ]),
        ...mapState({
            getDeliverableTemplateSlug(state, getters) {
                return getters['getDeliverableTemplateSlug']
            },
        }),
        chatWindowHeight() {
            let height = '300px';
            const deliverableTemplateSlug = this.getDeliverableTemplateSlug(parseInt(this.primaryParticipantType));
            if (deliverableTemplateSlug == "media-call") {
                height = '500px';
            }
            return height;
        }
    },
    methods: {
        messageSelectionActionHandler(obj) {
            console.log("messageSelectionActionHandler", obj.detail[0]);
            const { roomId, action, messages } = obj.detail[0];
            //messages is type array
            switch (action.name) {
                case "deleteMessages":
                    // call a method to delete selected messaged
                    this.deleteMessages(obj);
                case "shareMessage":
                // call a method to forward selected messaged with another user
            }
        },

        async fetchChatRoomInfo() {
            try {
                this.roomsLoaded = false;
                const params = {
                    primaryParticipantId: this.primaryParticipantId
                };
                const payload = {
                    params,
                    chatNamespace: this.chatNamespace
                };
                const response = await this.$store.dispatch(
                    this.chatNamespace + "/fetchChatRoomInfo",
                    payload
                );

                if (response) {
                    const usersArray = this.allActiveUsers.map(user => ({
                        _id: user.id,
                        username: user.name
                    }));
                    response.users = usersArray;
                    this.rooms = [response];
                    this.roomsLoaded = true;
                    // add custom field users and task users as chat participants
                    // chat participants will see chat bubble with unread message count in list pages
                    this.addNewChatParticipants();
                }
            } catch (error) {
                console.error("Error fetching rooms:", error);
            }
        },

        async addNewChatParticipants() {
            if (this.roomsLoaded) {
                const payload = {
                    roomId: this.rooms[0].roomId,
                    primaryParticipantId: this.primaryParticipantId,
                    chatNamespace: this.chatNamespace
                };
                await this.$store.dispatch(
                    this.chatNamespace + "/addNewChatParticipants",
                    payload
                );

            } else {
                console.warn("Room not initialized yet to add new participants");
            }
        },

        async fetchMessages(obj) {
            if (
                this.roomsLoaded &&
                obj.detail[0].room.roomId &&
                !this.allMessagesLoaded
            ) {
                let page;
                if (obj?.detail[0]?.options?.reset == true) {
                    // reset:true, initial load
                    this.pageNumber = page = 1;
                } else {
                    // options undefined, do pagination
                    page = this.pageNumber;
                }
                const params = {
                    roomId: obj.detail[0].room.roomId,
                    primaryParticipantId: this.primaryParticipantId,
                    page
                };
                const payload = {
                    chatNamespace: this.chatNamespace,
                    params
                };
                const response = await this.$store.dispatch(
                    this.chatNamespace + "/fetchMessages",
                    payload
                );
                const vacMessagesObjArray = response.data;
                if (vacMessagesObjArray) {
                    if (page == 1) {
                        this.messages.push(...vacMessagesObjArray);
                    } else {
                        this.messages = [
                            ...vacMessagesObjArray,
                            ...this.messages
                        ];
                    }
                }
                if (this.messages.length >= response.total) {
                    // messages-loaded must be set to true when all messages of a conversation have been loaded.
                    // Meaning the user cannot scroll on top to load more paginated messages
                    this.allMessagesLoaded = true;
                } else {
                    this.pageNumber++;
                }
                if (obj?.detail[0]?.options?.reset == true) {
                    // reset:true = initial load, call PUT only once on initial load 
                    // not on every api fetch older message GET request
                    if (Array.isArray(this.messages) && this.messages.length) {
                        // call PUT only after latest messages are loaded 
                        // messages array exists and conversation is not empty
                        this.markWholeConversationAsRead(obj.detail[0].room.roomId);
                    }
                    this.lastUpdatedTimestamp = this.$moment().utc().format('YYYY-MM-DD HH:mm:ss.SSS');
                }
            } else {
                console.warn("Room not initialized yet");
            }
        },

        async markWholeConversationAsRead(roomId) {
            if (this.roomsLoaded) {
                if (Array.isArray(this.messages) && this.messages.length) {
                    // messages array exists and is not empty
                    const unseenMessageIds = this.messages
                        .filter(message => message.seen == false)
                        .map(message => message._id);
                    const unseenMessagesCount = unseenMessageIds.length;
                    if (unseenMessagesCount > 0) {
                        // there are unread messages
                        let readWholeConversationFlag = false;
                        if (unseenMessagesCount === this.messages.length) {
                            readWholeConversationFlag = true;
                        }
                        // else pass in unread message id array and update them
                        await new Promise(resolve => setTimeout(resolve, 10000));
                        const payload = {
                            roomId,
                            readWholeConversationFlag,
                            unseenMessageIds,
                            primaryParticipantId: this.primaryParticipantId,
                            chatNamespace: this.chatNamespace,
                        };
                        const totalUnread = await this.$store.dispatch(
                            this.chatNamespace + "/markAllAsRead",
                            payload
                        );
                        if (totalUnread == 0) {
                            // Update messages array seen flag to hide NewMessagesDivider 
                            this.messages = this.messages.map(message => ({
                                ...message,
                                seen: true
                            }));
                        }
                    }
                } else {
                    console.warn("No messages to mark as read");
                }
            } else {
                console.warn("Room not initialized yet to mark as read");
            }
        },

        async convertBlobUrlToFile(fileData) {
            const response = await fetch(fileData.localUrl);
            const blobData = await response.blob();
            const file = new File([blobData], fileData.name, {
                type: fileData.type
            });
            return file;
        },
        async sendMessage(obj) {
            //If attachments are there, convert them to file and sent to Laravel Backend
            let actualFileArray = [];
            if (obj.detail[0].files && obj.detail[0].files?.length > 0) {
                await Promise.all(
                    obj.detail[0].files.map(async file => {
                        let fileContent = await this.convertBlobUrlToFile(file);
                        actualFileArray.push(fileContent);
                    })
                );
            }

            const formData = new FormData();
            actualFileArray.forEach((file, index) => {
                formData.append(`${index}`, file);
            });
            formData.append("primaryParticipantId", this.primaryParticipantId);
            Object.entries(obj.detail[0]).forEach(([key, value]) => {
                if (key === "replyMessage") {
                    if (obj.detail[0].replyMessage) {
                        formData.append(
                            "replyMessage",
                            JSON.stringify(obj.detail[0].replyMessage)
                        );
                    }
                } else if (key === "usersTag") {
                    formData.append("usersTag", JSON.stringify(obj.detail[0].usersTag));
                } else {
                    formData.append(key, value);
                }
            });
            const payload = {
                formData,
                chatNamespace: this.chatNamespace
            };
            const response = await this.$store.dispatch(
                this.chatNamespace + "/sendMessage",
                payload
            );
            if (response) {
                this.messages.push(response);
            }
        },

        async editMessage(obj) {
            const payload = {
                ...obj.detail[0],
                primaryParticipantId: this.primaryParticipantId,
                chatNamespace: this.chatNamespace
            };
            const response = await this.$store.dispatch(
                this.chatNamespace + "/updateMessage",
                payload
            );
            this.messages.forEach(obj => {
                if (obj._id == response._id) {
                    // update message instead of additional GET request
                    obj.content = response.content;
                    obj.edited = true;
                    obj.seen = false;
                }
            });
        },

        async deleteMessagesFunction(obj, messagesToDeleteArray, roomId) {
            const payload = {
                chatNamespace: this.chatNamespace,
                data: {
                    messagesToDelete: messagesToDeleteArray,
                    primaryParticipantId: this.primaryParticipantId,
                    roomId
                }
            };
            const response = await this.$store.dispatch(
                this.chatNamespace + "/deleteMessage",
                payload
            );
            const deletedIds = response.messagesDeleted;
            this.messages.forEach(obj => {
                if (deletedIds.includes(obj._id)) {
                    // update deleted as true for message instead of additional GET request
                    obj.deleted = true;
                }
            });
        },

        async deleteMessages(obj) {
            this.deleteMessagesFunction(
                obj,
                [...obj.detail[0].messages],
                obj.detail[0].roomId
            );
        },

        async deleteMessage(obj) {
            this.deleteMessagesFunction(
                obj,
                [obj.detail[0].message],
                obj.detail[0].roomId
            );
        },

        sendMessageReaction(obj) {
            console.log(obj);
        },

        async refreshMessages(newMessageCount) {
            const params = {
                roomId: this.rooms[0].roomId,
                primaryParticipantId: this.primaryParticipantId,
                page: 1,
                limit: newMessageCount
            };
            const payload = {
                chatNamespace: this.chatNamespace,
                params
            };
            const response = await this.$store.dispatch(
                this.chatNamespace + "/fetchMessages",
                payload
            );
            const vacMessagesObjArray = response.data;
            if (Array.isArray(vacMessagesObjArray) && vacMessagesObjArray.length) {
                vacMessagesObjArray.forEach((obj, index) => {
                    setTimeout(() => {
                        this.messages.push(obj);
                    }, index * 100);
                });
            }
        },

        markNewMessageAsRead() {
            // this custom event is emitted when clicked on new message count svg icon
            // scrolls to make new messages visible inside chat container
            // mark newer messages as read
            if (this.roomsLoaded) {
                const roomId = this.rooms[0].roomId;
                if (Array.isArray(this.messages) && this.messages.length) {
                    this.markWholeConversationAsRead(roomId);
                }
            }
        },

        async getLastMessage() {
            // Call this function in an interval
            if (this.shouldRefreshMessages == false) {
                // Should not call if Chat box component is not in focus
                console.info("Chat Room not in focus");
                return;
            }
            if (this.roomsLoaded) {
                const roomId = this.rooms[0].roomId;
                if (Array.isArray(this.messages) && this.messages.length) {
                    // messages array exists and is not empty
                    const lastMessageObjInFE = this.messages[
                        this.messages.length - 1
                    ];
                    if (Object.hasOwn(lastMessageObjInFE, "_id")) {
                        const lastMessageIdInFE = this.messages[
                            this.messages.length - 1
                        ]?._id;
                        const messageIdsArray = this.messages.map(message => message._id);
                        const params = {
                            roomId,
                            lastMessageIdInFE,
                            primaryParticipantId: this.primaryParticipantId,
                            lastUpdatedTimestamp: this.lastUpdatedTimestamp,
                            messageIdsArray,
                        };
                        const payload = {
                            chatNamespace: this.chatNamespace,
                            params
                        };
                        const response = await this.$store.dispatch(
                            this.chatNamespace + "/getLastMessage",
                            payload
                        );
                        if (response.currentLoadedMessages && response.currentLoadedMessages.length > 0) {
                            // Update seen / deleted / edited / content in already loaded chat messages
                            response.currentLoadedMessages.forEach(updatedMsg => {
                                const index = this.messages.findIndex(message => message._id === updatedMsg._id);
                                if (index !== -1) {
                                    this.$set(this.messages, index, {
                                        ...this.messages[index],
                                        content: updatedMsg.content,
                                        edited: updatedMsg.edited,
                                        seen: updatedMsg.seen,
                                        deleted: updatedMsg.deleted,
                                    });
                                }
                            });
                            this.lastUpdatedTimestamp = this.$moment().utc().format('YYYY-MM-DD HH:mm:ss.SSS');
                        }
                        const newMessageCount = response.total;
                        if (newMessageCount > 0) {
                            // fetchMessages with page 1
                            // append to beginning of messages array
                            this.refreshMessages(newMessageCount);
                        }
                    } else {
                        console.warn("Last Message object invalid id");
                    }
                } else {
                    console.warn("Messages not initialized yet");
                }
            } else {
                console.warn("Room not initialized yet");
            }
        },

        addCustomStyle() {
            const style = document.createElement("style");
            style.textContent = `
            .vac-reply-content { max-height:200px; overflow:scroll; }
            .vac-message-wrapper .vac-message-box { max-width: 80%; }
            .vac-message-wrapper .vac-offset-current { margin-left: 20%; }
            `;
            if (this.$refs.vacRef && this.$refs.vacRef.shadowRoot) {
                this.$refs.vacRef.shadowRoot.appendChild(style);
            }
        }
    },
    mounted() {
        this.fetchChatRoomInfo();

        const vm = this;
        setTimeout(() => {
            // wait for the reference `this.$refs.vacRef` to be available
            vm.addCustomStyle();
        });

        // Check for new messages every 30 seconds
        this.interval = setInterval(this.getLastMessage, 10000);
    },
    watch: {
        primaryParticipantTitle(newVal) {
            if (this.rooms[0] && newVal) {
                this.rooms[0].roomName = newVal;
            }
        }
    },
    beforeDestroy() {
        // Clear the interval when the component is destroyed to prevent memory leaks
        clearInterval(this.interval);
    }
};
</script>
